import { css, styled } from 'styled-components';

import type { ApiListingLocationType } from '#/api/types/ApiListingLocationType';
import { Tag } from '#/components/Tag/Tag';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { Color } from '#/theme/theme';
import { colors } from '#/theme/theme';
import { getLocationTypeText } from '#/utils/listings/getLocationTypeText';

type Props = {
  listingType: string;
  locationType: ApiListingLocationType;
};

const LocationTypeColorMap = {
  REMOTE: 'brightPlum',
  HYBRID: 'secondarySkyBlue',
  ONSITE: 'brandGreen',
} satisfies Record<ApiListingLocationType, Color>;

const StyledTag = styled(Tag)<{ $locationType: ApiListingLocationType }>`
  ${({ $locationType }) => {
    if ($locationType === 'REMOTE')
      return css`
        color: ${colors.white};
        background-color: ${colors[LocationTypeColorMap.REMOTE]};
        border-color: ${colors[LocationTypeColorMap.REMOTE]} !important;
      `;

    if ($locationType === 'HYBRID')
      return css`
        color: ${colors.white};
        background-color: ${colors[LocationTypeColorMap.HYBRID]};
        border-color: ${colors[LocationTypeColorMap.HYBRID]} !important;
      `;

    if ($locationType === 'ONSITE')
      return css`
        color: ${colors.white};
        background-color: ${colors[LocationTypeColorMap.ONSITE]};
        border-color: ${colors[LocationTypeColorMap.ONSITE]} !important;
      `;
  }};
`;

export function ListingLocationTypeLabel({ listingType, locationType }: Props) {
  const { i18n } = useI18n();

  return (
    <StyledTag $locationType={locationType} size="micro">
      {getLocationTypeText(i18n, listingType, locationType)}
    </StyledTag>
  );
}
